/**
 * Mesma política que /onboarding/password (SetPassword) e a API (validateNewPassword).
 */
export const PASSWORD_POLICY_CHECKS = [
  { id: "len", test: (s) => String(s).length >= 8 },
  { id: "upper", test: (s) => /[A-Z]/.test(s) },
  { id: "num", test: (s) => /\d/.test(s) },
  { id: "sym", test: (s) => /[^A-Za-z0-9]/.test(s) },
];

export function passwordPolicyScore(s) {
  return PASSWORD_POLICY_CHECKS.reduce((n, c) => n + (c.test(s) ? 1 : 0), 0);
}

export function passwordPolicyMet(s) {
  return PASSWORD_POLICY_CHECKS.every((c) => c.test(s));
}
